import React from 'react';
import { Bot, Sparkles } from 'lucide-react';

import { COACH_ASSISTANTS } from './coachChatConfig';

export const CoachModelSelector = ({ activeAssistant, busy, onChange }) => (
  <div
    className="grid grid-cols-2 gap-1 border-b border-[#0a1f44]/10 bg-[#eef1f6] p-1.5"
    data-testid="coach-model-selector"
    aria-label="Choose coach assistant"
    role="group"
  >
    {Object.entries(COACH_ASSISTANTS).map(([key, option]) => {
      const Icon = key === 'claude' ? Sparkles : Bot;
      const active = key === activeAssistant;
      return (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          disabled={busy}
          aria-pressed={active}
          data-testid={`coach-model-${key}`}
          className={`min-h-11 px-2 text-left transition-[background-color,color,transform] duration-200 disabled:cursor-not-allowed ${
            active
              ? 'bg-[#0a1f44] text-white shadow-sm'
              : 'bg-white text-[#0a1f44] hover:bg-[#dfe5ee] active:scale-[0.98]'
          }`}
        >
          <span className="flex items-center gap-2 text-xs font-heading font-bold uppercase tracking-wider">
            <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
            {option.shortLabel}
          </span>
          <span className={`mt-0.5 block text-[10px] ${active ? 'text-white/70' : 'text-[#0a1f44]/55'}`}>
            {option.modelLabel}
          </span>
        </button>
      );
    })}
  </div>
);